import { ElementRef, Injectable, OnDestroy, WritableSignal, afterNextRender, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ResizeObserverClass implements OnDestroy {
  private resizeObserver: ResizeObserver;
  private callback?: (entry: ResizeObserverEntry) => void;

  // Signals for width and height
  public width: WritableSignal<number> = signal(0);
  public height: WritableSignal<number> = signal(0);

  constructor() {
    afterNextRender(() => {
      // Initialize ResizeObserver and use signals to store width and height
      this.resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          // sync with the next repaint of the browser
          requestAnimationFrame(() => {
            this.width.set(entry.contentRect.width);
            this.height.set(entry.contentRect.height);

            if (this.callback) {
              this.callback(entry);
            }
          });
        }
      });
    });
  }

  /**
   * Start observing the host element for resize events.
   * @param elementRef ElementRef of the host element.
   * @param callback Optional callback to handle resize events.
   */
  observe(elementRef: ElementRef, callback?: (entry: ResizeObserverEntry) => void): void {
    this.callback = callback;

    const element = elementRef.nativeElement;
    if (element) {
      this.resizeObserver.observe(element);
    }
  }

  /**
   * Disconnect the observer when the object is destroyed.
   */
  ngOnDestroy(): void {
    if(this.resizeObserver){
      this.resizeObserver.disconnect();
    }
  }
}
